import React from 'react'
import Tabs from 'core/elements/tabs'
import Tab from 'core/elements/tabs/Tab'
import { routeManager } from 'core/utils/routes'
import { IGpuPageTabs } from './model'
import GpuHostsListPage from './GpuHostsListPage'

export default function GpuPage() {
  return (
    <Tabs route={routeManager.routes.openstack.gpuPage}>
      <Tab label="GPU Hosts" value={IGpuPageTabs.Hosts}>
        <GpuHostsListPage />
      </Tab>
      {/* <Tab label="GPU Leases" value={IGpuPageTabs.Leases}>
        <div>Leases</div>
      </Tab> */}
    </Tabs>
  )
}
